import { MapSearchFilter } from '@/types';
import { GroupCode, ItemType } from '@remodeling/shop';

export const SHOP_DETAIL_VIEW_TYPE_DESIGNPARK = 1;
export const SHOP_DETAIL_VIEW_TYPE_SHOWROOM = 2;
export const SHOP_DETAIL_VIEW_TYPE_RHKB = 3;
export const SHOP_DETAIL_VIEW_TYPE_INTERIOR = 4;

export const SHOP_ITEM_TYPE: { code: ItemType; name: string }[] = [
  {
    code: 'RM',
    name: '리모델링',
  },
  {
    code: 'KC',
    name: '부엌',
  },
  {
    code: 'BR',
    name: '욕실',
  },
  {
    code: 'BS',
    name: '빌트인수납',
  },
  {
    code: 'FN',
    name: '가구',
  },
  {
    code: 'HG',
    name: '생활용품',
  },
  {
    code: 'CF',
    name: '커튼·블라인드',
  },
  {
    code: 'IF',
    name: '수입가구',
  },
];

export const SHOP_REMODELING_FILTER: MapSearchFilter[] = [
  { id: 0, text: '전체', code: 'ALL' },
  { id: 1, text: '리하우스', code: 'RH' },
  { id: 2, text: '키친&바스', code: 'KB' },
  { id: 3, text: '보여주는집', code: 'OH' },
];

export const SHOP_COMBINE_FILTER: MapSearchFilter[] = [
  { id: 0, text: '리모델링', code: 'RM' },
  { id: 1, text: '부엌', code: 'KC' },
  { id: 2, text: '욕실', code: 'BR' },
  { id: 3, text: '가구', code: 'FN' },
  { id: 4, text: '생활용품', code: 'HG' },
  { id: 5, text: '커튼·블라인드', code: 'CF' },
  { id: 6, text: '수입가구', code: 'IF' },
  { id: 7, text: '빌트인수납', code: 'BS' },
];

export const SHOP_GROUP_CODE_OPTIONS: { value: GroupCode; text: string }[] = [
  { value: 'ALL', text: '전체매장' },
  { value: 'RH', text: '리하우스' },
  { value: 'KB', text: '키친&바스' },
];

export const SOUTH_KOREA_LAT = 35.6;
export const SOUTH_KOREA_LNG = 128;
export const SOUTH_KOREA_LEVEL_MAX = 13;
export const SOUTH_KOREA_LEVEL_MIN = 11;
export const KAKAO_MAP_LEVEL_MAX = 13;
export const SI_DO_LEVEL = 10;
export const GUN_GU_LEVEL = 8;
export const CURRENT_LEVEL = 5;
